import {RouterModule, Routes} from "@angular/router";
import {FP_ROUTES, FS_ROUTES, HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES} from "../core/constants";
import {Auth2Guard} from "../core/services/security/auth2.guard";
import {NgModule} from "@angular/core";
import {FacturesFournisseursComponent} from "./fournisseurs/factures/factures-fournisseurs.component";
import {FacturesRootComponent} from "./factures-root.component";
import {AvoirFournisseurComponent} from "./fournisseurs/avoirs/avoir-fournisseur.component";
import {PointFacturationComponent} from "./clients/points-facturation/point-facturation.component";
import {FacturesClientsComponent} from "./clients/factures/factures-clients.component";
import {FacturationClientParametrageComponent} from "./clients/parametrage/facturation-client-parametrage.component";
import {TableauDeBordComponent} from "./clients/tableau-de-bord/tableau-de-bord.component";

const routes: Routes = [
  {
    path: FP_ROUTES.FACTURES,
    component: FacturesRootComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [Auth2Guard],
    canActivateChild: [Auth2Guard],
    data: HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES /* || HAS_ROLE_PLC_FACTURES */,
    children: [
      {
        path: FS_ROUTES.POINT_FACTURATION,
        component: PointFacturationComponent,
        runGuardsAndResolvers: 'always',
        data: HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES
      },
      {
        path: FS_ROUTES.FACTURATION_CLIENT_PARAMETRAGE,
        component: FacturationClientParametrageComponent,
        runGuardsAndResolvers: 'always',
        data: HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES
      },
      {
        path: FS_ROUTES.FACTURES_CLIENTS,
        component: FacturesClientsComponent,
        runGuardsAndResolvers: 'always',
        data: HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES
      },
      {
        path: FS_ROUTES.TABLEAU_DE_BORD,
        component: TableauDeBordComponent,
        runGuardsAndResolvers: 'always',
        data: HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES

      },
      {
        path: FS_ROUTES.FACTURES_FOURNISSEURS,
        component: FacturesFournisseursComponent,
        runGuardsAndResolvers: 'always',
        data: HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES
      },
      {
        path: FS_ROUTES.AVOIRS,
        component: AvoirFournisseurComponent,
        runGuardsAndResolvers: 'always',
        data: HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES
      }
    ]
  },
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FacturesRoutingModule {
}
